/* eslint no-console: ["error", { allow: ["warn", "error"] }] */
import apiService from '@services/apiService';

const AGENT_LOOKUP = 'AGENT_LOOKUP';
const AGENT_LOOKUP_FAIL = 'AGENT_LOOKUP_FAIL';
const AGENT_LOOKUP_SUCCESS = 'AGENT_LOOKUP_SUCCESS';

const AGENT_SEARCH = 'AGENT_SEARCH';
const AGENT_SEARCH_FAIL = 'AGENT_SEARCH_FAIL';
const AGENT_SEARCH_SUCCESS = 'AGENT_SEARCH_SUCCESS';

const CLEAR_AGENT = 'p9/agent/CLEAR_AGENT';

const FORM_SUBMITTED = 'FORM_SUBMITTED';

const GET_CURRENT_AGENT = 'GET_CURRENT_AGENT';
const GET_CURRENT_AGENT_FAIL = 'GET_CURRENT_AGENT_FAIL';
const GET_CURRENT_AGENT_SUCCESS = 'GET_CURRENT_AGENT_SUCCESS';

const HOME_BUTTON_CLICKED = 'HOME_BUTTON_CLICKED';
const LOAD_FORM_DEFINITION = 'LOAD_FORM_DEFINITION';

const SEARCH_LISTINGS_PAGE_CLICKED = 'SEARCH_LISTINGS_PAGE_CLICKED';
const SET_GROUP_TYPE = 'SET_GROUP_TYPE';

const LOAD_AGENT_PHOTO = 'p9/agent/LOAD_AGENT_PHOTO';
const LOAD_AGENT_PHOTO_SUCCESS = 'p9/agent/LOAD_AGENT_PHOTO_SUCCESS';
const LOAD_AGENT_PHOTO_FAIL = 'p9/agent/LOAD_AGENT_PHOTO_FAIL';

const SEARCH_AGENTS_PAGE_CLICKED = 'SEARCH_AGENTS_PAGE_CLICKED';

const SELECT_AGENT = 'p9/agent/SELECT_AGENT';
const SELECT_AGENT_FAIL = 'p9/agent/SELECT_AGENT_FAIL';
const SELECT_AGENT_SUCCESS = 'p9/agent/SELECT_AGENT_SUCCESS';

const SELECT_AGENT_LOOKUP = 'p9/agent/SELECT_AGENT_LOOKUP';
const SELECT_AGENT_LOOKUP_FAIL = 'p9/agent/SELECT_AGENT_LOOKUP_FAIL';
const SELECT_AGENT_LOOKUP_SUCCESS = 'p9/agent/SELECT_AGENT_LOOKUP_SUCCESS';

const initialState = {
  agentGroupType: null,
  agentLookup: null,
  agentPhotos: [],
  agentSearchResults: null,
  agentSelected: null,
  clearAgent: false,
  searchLoading: false,
  selectLoading: false,
  singleAgentPhoto: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_AGENT:
    case HOME_BUTTON_CLICKED:
    case SEARCH_LISTINGS_PAGE_CLICKED:
      return initialState;
    case SEARCH_AGENTS_PAGE_CLICKED:
      return {
        ...state,
        agentSearchResults: null,
        agentSelected: null,
      };
    case LOAD_FORM_DEFINITION:
      return {
        ...state,
        agentGroupType: null,
        agentLookup: null,
        agentSearchResults: null,
      };
    case SET_GROUP_TYPE:
      return {
        ...state,
        agentGroupType: action.groupType,
      };
    case AGENT_LOOKUP:
    case AGENT_SEARCH:
      return {
        ...state,
        agentPhotos: [],
        searchLoading: true,
        singleAgentPhoto: null,
      };
    case GET_CURRENT_AGENT:
    case SELECT_AGENT:
    case SELECT_AGENT_LOOKUP:
      return {
        ...state,
        agentPhotos: [],
        selectLoading: true,
        singleAgentPhoto: null,
      };
    case AGENT_LOOKUP_FAIL:
    case AGENT_SEARCH_FAIL:
      return {
        ...state,
        searchLoading: false,
      };
    case GET_CURRENT_AGENT_FAIL:
    case SELECT_AGENT_FAIL:
    case SELECT_AGENT_LOOKUP_FAIL:
      return {
        ...state,
        selectLoading: false,
        /* Error handling */
      };
    case AGENT_LOOKUP_SUCCESS:
    case AGENT_SEARCH_SUCCESS:
      return {
        ...state,
        agentSearchResults: action.payload.agents,
        searchLoading: false,
      };
    case GET_CURRENT_AGENT_SUCCESS:
    case SELECT_AGENT_LOOKUP_SUCCESS:
      return {
        ...state,
        agentLookup: action.payload.fullAgent,
        agentSearchResults: null,
        selectLoading: false,
      };
    case SELECT_AGENT_SUCCESS:
      return {
        ...state,
        agentPhotos: action.payload.agentPhotos,
        agentSelected: action.payload.fullAgent,
        agentSearchResults: null,
        selectLoading: false,
      };
    case FORM_SUBMITTED:
      return {
        ...state,
        agentSelected: null,
        agentPhotos: [],
        singleAgentPhoto: null,
      };
    case LOAD_AGENT_PHOTO_SUCCESS:
      return {
        ...state,
        singleAgentPhoto: action.payload,
      };
    default:
      return state;
  }
};

// Searches for agents
const agentSearch = agentCriteria => async dispatch => {
  dispatch({ type: AGENT_SEARCH });
  try {
    const agents = await apiService.Agent.searchAgent(agentCriteria);
    dispatch({
      type: AGENT_SEARCH_SUCCESS,
      payload: { agents },
    });
  } catch (err) {
    console.error('Error: Agent agentSearch', err);
    dispatch({ type: AGENT_SEARCH_FAIL });
  }
};

const agentLookup = agentCriteria => async dispatch => {
  dispatch({ type: AGENT_LOOKUP });
  try {
    const agents = await apiService.Agent.agentLookup(agentCriteria);
    dispatch({
      type: AGENT_LOOKUP_SUCCESS,
      payload: { agents },
    });
  } catch (err) {
    console.error('Error: Agent agentLookup', err);
    dispatch({ type: AGENT_LOOKUP_FAIL });
  }
};

const clearAgent = () => ({ type: CLEAR_AGENT });

const setAgentLookup = agentData => async dispatch => {
  dispatch({ type: SELECT_AGENT_LOOKUP });
  try {
    const selectedAgent = await apiService.Agent.selectAgent(agentData);
    const fullAgent = selectedAgent.agent;
    dispatch({
      type: SELECT_AGENT_LOOKUP_SUCCESS,
      payload: { fullAgent },
    });
  } catch (err) {
    console.error('Error: Agent setAgentLookup', err);
    dispatch({ type: SELECT_AGENT_LOOKUP_FAIL });
  }
};

const setCurrentAgent = agentData => async dispatch => {
  dispatch({ type: SELECT_AGENT });
  try {
    const selectedAgent = await apiService.Agent.selectAgent(agentData);
    const fullAgent = selectedAgent.agent;
    const agentPhotos = selectedAgent.photos;

    dispatch({
      type: SELECT_AGENT_SUCCESS,
      payload: { fullAgent, agentPhotos },
    });
  } catch (err) {
    console.error('Error: Agent setCurrentAgent', err);
    dispatch({ type: SELECT_AGENT_FAIL });
  }
};

const getCurrentAgent = () => async dispatch => {
  dispatch({ type: GET_CURRENT_AGENT });
  try {
    const selectedAgent = await apiService.Agent.getCurrentAgent();
    const fullAgent = selectedAgent[0];

    dispatch({
      type: GET_CURRENT_AGENT_SUCCESS,
      payload: { fullAgent },
    });
  } catch (err) {
    console.error('Error: Agent getCurrentAgent', err);
    dispatch({ type: GET_CURRENT_AGENT_FAIL });
  }
};

/*
 Retrieves the listing photo by using a photo identifier which can be either
   a file URL of form: https://[bucket-name].s3.[s3-region].amazonaws.com/[file-name],
   or a file name
*/
const loadAgentPhoto = photoUrlOrFileName => async dispatch => {
  dispatch({ type: LOAD_AGENT_PHOTO });
  try {
    const agentPhoto = await apiService.Photos.getSingleImage(photoUrlOrFileName);
    dispatch({
      type: LOAD_AGENT_PHOTO_SUCCESS,
      payload: agentPhoto,
    });
  } catch (error) {
    console.error('Error: Agent loadAgentPhoto', error);
    dispatch({ type: LOAD_AGENT_PHOTO_FAIL });
  }
};

export {
  agentLookup,
  agentSearch,
  clearAgent,
  getCurrentAgent,
  loadAgentPhoto,
  setAgentLookup,
  setCurrentAgent,
  SELECT_AGENT_SUCCESS,
};
